export const meetings = 'meetings/';
export const userEmail = 'user/email/';